import PeopleIcon from '@mui/icons-material/People';
import React from 'react';
import Controls from '../../components/Slider/Controls';
import Header from '../../components/Slider/Header';
import SplitSelection from '../../components/SplitSelection';
import ContactLocations from './ContactLocations';
import What from './JobDetails';
import NewEndUser from './NewEndUser';
import SelectEndUser from './SelectEndUser';

const NewOrExistingEndUser = ({onBack, onNext}) => (
  <>
    <Header>New or Existing?</Header>
    <SplitSelection
      sections={[
        {
          title: 'End User',
          icon: <PeopleIcon/>,
          buttons: [
            {
              label: 'Select An Existing End User',
              onClick: () => onNext({type: SelectEndUser.type, id: SelectEndUser.type})
            },
            {
              label: 'Create a New End User',
              onClick: () => onNext({type: NewEndUser.type, id: NewEndUser.type})
            },
          ]
        }
      ]}
    />
    <Controls
      onBack={() => onBack({type: ContactLocations.type, id: ContactLocations.type})}
      onNext={() => onNext({type: What.type, id: What.type})}
      nextLabel="Skip to Job Details"
    />
  </>
);

NewOrExistingEndUser.type = 'NEW_OR_EXISTING_END_USER';

export default NewOrExistingEndUser;
